import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Account } from 'src/app/models/account';
import { CustomValidators } from 'src/app/lib/customer-validators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AccountService } from 'src/app/services/account.service';
import { Router } from '@angular/router';
import { TimeZoneService } from 'src/app/services/timezone.service';

declare var grecaptcha: any;
const RECAPTCHA_SITE_KEY = '6LfUIa4tAAAAAFimDk6ry_5984QvsQ8EMgqGz_R3';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  public registerForm: FormGroup;
  private account: Account = new Account();
  public errors = [];
  public showSuccess:boolean=false;
  public resendEmail:string='';
  public response:string='';
  public roles=[];
  public loggedIn:boolean;
  // TimeZone
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;
  public AucklandTimeZone:boolean = false;
  public EUTimeZone:boolean = false;
  public CanadaTimeZone:boolean = false;
  public UAETimeZone:boolean = false;

  constructor(
    private authService: AuthenticationService,
    private accountService: AccountService,
    private _router: Router,
    private timezoneService: TimeZoneService
  )
  {
    this.authService.loggedIn.subscribe(state=>{
      this.loggedIn = state;
    })
    this.registerForm = new FormGroup({
      'email': new FormControl(this.account.email, [
        Validators.email,
        Validators.required
      ]),
      'first_name': new FormControl(this.account.first_name, Validators.required),
      'last_name': new FormControl(this.account.last_name, Validators.required),
      'password': new FormControl(null, Validators.required),
      'password_confirmation': new FormControl(null, Validators.required),
      'code': new FormControl(null),
      'type': new FormControl(null,Validators.required),
      'opt': new FormControl(null, Validators.required),
    },{
      validators: CustomValidators.MatchPassword
    });
  }

  ngOnInit() {
    this.getUserRoles();
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.AucklandTimeZone = this.timezoneService.checkAucklandTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
    this.UAETimeZone = this.timezoneService.checkUAETimeZone();
  }

  getUserRoles(){
    this.accountService.getRoles().subscribe(
      res=>{
        this.roles=res;
      }
    );
  }

  public resendVerification(){
    this.response='';
    if(this.resendEmail==''){
      return alert('Please provide an email address.');
    }
    this.authService.resendVerification(this.resendEmail).subscribe(
      res=>{
        this.response=res.message;
      }
    );
  }

  register(){

    this.errors = [];

    grecaptcha.ready(() => {
      grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: 'register'}).then((token) => {

        const payload = {...this.registerForm.value, recaptcha_token: token};

        this.authService.register(payload).subscribe(res=>{

          if(this.errors.length < 1) this.authService.registerBrevoV1(this.registerForm.value);
          this._router.navigate(['register/success']);
          this.showSuccess=true;
        },err=>{
          let errorObject = JSON.parse(err.error);
          Object.entries(errorObject).forEach((k, v) =>{
            this.errors.push(k[1][0]);
          });
        })
      });
    });
  }

}
